export default "__VITE_PUBLIC_ASSET__94d87449__"